import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resizeParent } from '../../services/Utils'

// Actions
import { configure } from '../../actions/Settings'
import { getCCBEvents } from '../../actions/ccb'

// Components
import Spinner from '../Spinner';
import DefaultEventCard from '../Cards/DefaultEventCard';
// Styles
import styles from './CCBEvents.css';

// Class
class CCBEvents extends Component {

    constructor(props){

        super(props);

        this.state = {
            page: 1,
            loaded: false,
            className: styles.loading,
            loadingText: (!props.loadingtext) ? '' : props.loadingtext,
            location: (!props.location) ? '' : props.location,
            type: (!props.type) ? '' : props.type,
            grouping: (!props.grouping) ? '' : props.grouping,
        }
    }

    getEvents(){

        let args = {
            page: this.state.page,
        }

        this.props.getCCBEvents(args)

    }

    loadMore(){
        this.setState({page: this.state.page+1},this.getEvents)
    }

    componentDidMount(){

        this.props.configure(this.props.site);
        this.getEvents();
        setTimeout(() =>{

            this.setState({
                loaded: true,
                className: styles.CCBEvents
            })
        },1000);

    }

    componentDidUpdate(){
        resizeParent();
    }

    renderCards(){
       
        return this.props.ccb.events.map((item,index) => {
                const url = this.props.site + '/ccb/event/' + item.id;

                // Apply Filters
                if(this.state.location && (this.state.location.toLowerCase() !== item.location.toLowerCase())) return null;
                if(this.state.type && (this.state.type.toLowerCase() !== item.group_type.toLowerCase())) return null;
                if(this.state.grouping && (this.state.grouping.toLowerCase() !== item.grouping_name.toLowerCase())) return null;


                return (<DefaultEventCard {...item} key={index} url={url} />)
            }
        )

    }

    render() {

        // Guard: Not loaded
        if(!this.props.ccb.events) return (<div className={this.state.className}><Spinner text={this.state.loadingText} /></div>);

        return (
            <div className={this.state.className}>

                <div className="posts-loop">{this.renderCards()}</div>
                {(this.props.ccb.ui != 'loading' && (
                    <div className="load-more">
                        <button onClick={() => this.loadMore()}>Load More</button>
                    </div>
                ))}

            </div>
        );
    }
}

const mapStateToProps = state => ({
    ccb: state.ccb,
    settings: state.Settings
})

const mapDispatchToProps = dispatch => ({
    configure: (site) => dispatch(configure(site)),
    getCCBEvents: (args) => dispatch(getCCBEvents(args))
})

export default connect(mapStateToProps, mapDispatchToProps)(CCBEvents);
